export default __webpack_public_path__ + "static/media/Large-Bread-4.90dce2b5.jpg";